import axiosInstance from 'api/axiosInstance';

export interface StatusOption {
	Id: number;
	Title: string;
}

const searchStatuses = async (keyword: string): Promise<StatusOption[]> => {
	try {
		const { data } = await axiosInstance.get(
			`/api/cantrackv3/Statuses?Id=0&SearchKeyword=${encodeURIComponent(keyword)}&Page=1&Take=50`,
		);
		return Array.isArray(data) ? data : data?.Data || [];
	} catch (error) {
		console.error('[searchStatuses] Failed:', error);
		throw error;
	}
};

export default searchStatuses;
